<template>

    <section id="administration">
        <h2>Administration</h2>
        <nav>
            <a target="_blank" href="/api/admin/"><strong>Administrationsmodul</strong></a>
            <a target="_blank" href="/api/admin/booking/room/"><span>Redigér lokaler</span></a>
            <a target="_blank" href="/api/admin/booking/booking/"><span>Redigér reservationer</span></a>
            <a target="_blank" href="/api/admin/authorization/guest/"><span>Redigér borgere</span></a>
            <a target="_blank" href="/api/admin/auth/user/?is_staff__exact=1"><span>Redigér ansatte</span></a>
        </nav>
    </section>

</template>

<script>

    export default {
        
    }

</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    #administration {
        
        nav a {
            display: flex;
            padding: .5rem 0;
            border-top: solid 1px $grey1;
            text-decoration: none;
            justify-content: space-between;
            align-items: center;

            &::after {
                content: '➔';
                font-size: 1.33rem;
                margin-left: 1rem;
            }
        }
    }

</style>
